import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const Faq = ({ items, title }) => {
  const [open, setOpen] = useState(0);
  return (
    <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6" data-testid="faq-section">
      <h2 className="font-display text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl">{title}</h2>
      <div className="mt-8 divide-y divide-slate-800/70 rounded-2xl border border-slate-800/70 bg-card/60">
        {items.map(([q, a], i) => (
          <div key={i}>
            <button
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-semibold text-slate-200 transition-colors hover:text-amber-300"
              onClick={() => setOpen(open === i ? -1 : i)}
              data-testid={`faq-question-${i}`}
              aria-expanded={open === i}
            >
              {q}
              <ChevronDown size={18} className={`shrink-0 text-amber-400 transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <p className="px-6 pb-6 text-sm leading-relaxed text-slate-400" data-testid={`faq-answer-${i}`}>{a}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};
